import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Company } from '../models/company';
import { Funder } from '../models/funder';
import { getCurrentApiDomain } from '../helpers/helper-functions';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  apiUrl = getCurrentApiDomain('');

  constructor(private http: HttpClient) {

  }

  login(e: string, p: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http.post(
      this.apiUrl + '/web/login',
      {
        username: e,
        password: p,
      },
      options
    );
  }


  memberLogin(formData: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http.post<any>(
      this.apiUrl + '/web/member-login',
      formData,
      options
    );
  }

  signup(n: string, e: string, p: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/signup',
      {
        name: n,
        email: e,
        password: p,
      },
      options
    );
  }

  requestPasswordReset(email: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/request-password-reset',
      {
        email: email,
      },
      options
    );
  }

  resetPassword(password: string, token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/reset-password',
      {
        token: token,
        password: password,
      },
      options
    );
  }


  logout() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(this.apiUrl + '/token/revoke', options);
  }

  getFundersList() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<any>>(this.apiUrl + '/get-all-funders', options);
  }


  getStaffUser(token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    };

    return this.http.get<User>(this.apiUrl + '/staff-user', options);
  }


  getMemberUser(token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    };

    return this.http.get<User>(this.apiUrl + '/member-user', options);
  }


  memberOneTimePasswordLogin(phoneNumber: string, otp: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/member-otp-login/${phoneNumber}/${otp}`, options);
  }

  providerOneTimePasswordLogin(nationalId: string, otp: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/provider-otp-login/${nationalId}/${otp}`, options);
  }

  agentGroupOneTimePasswordLogin(nationalId: string, otp: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/agent-group-otp-login/${nationalId}/${otp}`, options);
  }


  requestMemberOneTimePassword(nationalId: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/request-member-otp/${nationalId}`, options);
  }

  requestProviderOneTimePassword(nationalId: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/request-provider-otp/${nationalId}`, options);
  }

  requestAgentGroupOneTimePassword(nationalId: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/request-agent-group-otp/${nationalId}`, options);
  }

  providerRegister(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http.post<any>(this.apiUrl + `/web/provider-sign-up`, data, options);
  }

  agentGroupRegister(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http.post<any>(this.apiUrl + `/web/agent-group-sign-up`, data, options);
  }

  providerResetPassword(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<any>(this.apiUrl + `/web/provider-reset-password`, data, options);
  }

  agentGroupResetPassword(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<any>(this.apiUrl + `/web/agent-group-reset-password`, data, options);
  }

  getCompany(token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    };
    return this.http.get<Company>(this.apiUrl + '/company', options);
  }

  saveTokenAndUser(token: any, user: any) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', JSON.stringify(token.token));
    localStorage.setItem('access_token', token.accessToken);
  }

  getCurrentUserFromLocal(): User {
    return new User(JSON.parse(localStorage.getItem('user')!));
  }


  getCurrentFunderFromLocal(): Funder {
    const fundersList = JSON.parse(localStorage.getItem('funders_list')!).map((el: any) => new Funder(el));
    const currentFunderDomain = localStorage.getItem('current_portal_domain');
    return fundersList.filter((el: any) => el.funder_settings.domain == currentFunderDomain)[0];
  }
}
